
import React from "react";
import { LogoIcon } from "../../icons-svg";

const Logo = () => {
  return (
    <div className="flex items-center space-x-4 px-4 min-h-[47px] dark:bg-gray-700 shadow-sm">
      <LogoIcon className="w-28 h-auto" />
    </div>
  );
};

export default Logo;